import { useState } from 'react';
import axios from 'axios';
import API_URL from '../config';

function Register() {

  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    role: 'candidate'
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async () => {
    try {
      const res = await axios.post(
        `${API_URL}/auth/register`,
        form
      );

      alert(res.data.message);
      window.location.href = "/";

    } catch (err) {
      alert("Registration failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">

      <div className="bg-white p-6 rounded shadow w-96">

        <h2 className="text-xl font-bold mb-4">Register</h2>

        <input name="name" placeholder="Name" onChange={handleChange}
          className="w-full border p-2 mb-2" />

        <input name="phone" placeholder="Phone" onChange={handleChange}
          className="w-full border p-2 mb-2" />

        <input name="email" placeholder="Email" onChange={handleChange}
          className="w-full border p-2 mb-2" />

        <input name="password" type="password" placeholder="Password" onChange={handleChange}
          className="w-full border p-2 mb-2" />

        <select name="role" onChange={handleChange}
          className="w-full border p-2 mb-3">

          <option value="candidate">Job Seeker</option>
          <option value="institution">Institution</option>

        </select>

        <button
          onClick={handleRegister}
          className="w-full bg-blue-500 text-white p-2 rounded"
        >
          Register
        </button>

      </div>
    </div>
  );
}

export default Register;